import { render, staticRenderFns } from "./adminFeeConfigList.vue?vue&type=template&id=e8f1f316&scoped=true"
import script from "./adminFeeConfigList.vue?vue&type=script&lang=js"
export * from "./adminFeeConfigList.vue?vue&type=script&lang=js"
import style0 from "./adminFeeConfigList.vue?vue&type=style&index=0&id=e8f1f316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f1f316",
  null
  
)

export default component.exports